<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td>
                    <select v-model="form.syear" disabled>
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                    <a
                      style="position: absolute; right: 20%"
                      href="/PdpsCli/download/F101_UserGuide.pdf"
                      target="_blank"
                      >下載操作說明</a
                    >
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td>
                    <p>
                      <label>
                        <input type="radio" value="1" v-model="form.govtype" />
                        一般機關</label
                      >
                      <label>
                        <input
                          type="radio"
                          v-model="form.govtype"
                          value="2"
                          disabled
                        />
                        其他機關</label
                      >
                    </p>
                    <ul>
                      <tree-item
                        class="item"
                        :item="dropDownList.GovTree"
                        @make-folder="makeFolder"
                      ></tree-item>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>參與抽籤總人數</td>
                  <td>
                    <input
                      type="text"
                      disabled="disabled"
                      size="10"
                      maxlength="10"
                      v-model="form.modelCount"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="統計參與抽籤人數"
                      @click="btnLotcount()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="瀏覽參與抽籤人員名單"
                      @click="btnLotFindList()"
                    />
                  </td>
                </tr>
                <tr>
                  <td>實質審查抽籤比例</td>
                  <td>
                    <input type="text" size="10" v-model="form.num" />
                    %
                  </td>
                </tr>
                <tr>
                  <td>前後年度財產比對抽籤比例</td>
                  <td>
                    <input
                      type="text"
                      size="10"
                      maxlength="10"
                      v-model="form.num2"
                    />
                    %
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_left">
                    注意事項：<br />
                    1.「參與抽籤總人數」係以該年度上傳成功者(含紙本上傳)為
                    抽籤基數。<br />
                    2.使用本項抽籤功能，應先以「B102紙本上傳維護」功能維護
                    紙本上傳申報人資料，俾利正確統計人數。<br />
                    3.請參考「操作說明」後，審慎使用本功能，所有抽籤歷程將予以詳細記錄以備查。<br />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="抽籤"
                          @click="btnDrawLots()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
      </div>
    </div>
    <PdisFooter />
    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertRe v-model="AlertRe.show" :title="AlertRe.title">
      <div style="text-align: center">
        <p>已有抽籤資料，是否要重新抽籤？</p>
        <div>
          <button class="btn" @click="AlertRe.btnReDrawLots()">確定</button>
          <button class="btn" @click="AlertRe.btnDrawLotsClose()">取消</button>
        </div>
      </div>
    </AlertRe>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import TreeItem from "@/components/Common/TreeItem.vue";
import { getMenuIndex, getMenu } from "@/config/util.js";
import {
  F101_init,
  F101_Drawlots,
  F101_ReDrawlots,
  F101_Lotcount,
  F101_LotFindList,
} from "@/service/api.js";
export default {
  name: "F101",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F101",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      dropDownList: {
        syears: [],
        GovTree: {},
      },
      form: {
        syear: String(new Date().getFullYear() - 1911 - 1),
        govtype: "1",
        CHECK_EDNODES: [],
        //實質審查抽籤比例
        num: "",
        //前後年度財產比對抽籤比例
        num2: "",
        modelCount: "",
      },
      grid: {},
      LoginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      //登入資訊
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertRe: {
        show: false,
        title: "",
        txt: "",
        btnDrawLotsClose: function () {
          this.show = false;
        },
        btnReDrawLots: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    TreeItem,
    AlertRe: VueModal,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    doTree: function () {
      const self = this;
      let postData = {
        syear: self.form.syear, //去年
        loginlayer: 0,
        logingovcode: self.LoginInfo.govCode,
      };
      F101_init(postData).then((rData) => {
        this.dropDownList.GovTree = rData.returnObject.treeOutDatas[0];
      });
    },
    makeFolder: function (item) {
      Vue.set(item, "children", []);
      this.addItem(item);
    },
    //抽籤
    btnDrawLots: function () {
      const self = this;
      if (self.form.num.trim() == "") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請填寫實質審查抽籤比例"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }
      if (self.form.num2.trim() == "") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請填寫前後年度財產比對抽籤比例"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }
      if (self.form.modelCount == 0 || self.form.modelCount == "") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請先選擇抽籤機構並按下統計人數"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }

      self.form.CHECK_EDNODES = sessionStorage.getItem("TreeItem");
      let postData = {
        RANK: "", //國防部專用
        LOGINID: self.LoginInfo.id,
        LOGINGOVCODE: self.LoginInfo.govCode,
        LOGINGOVCODESTR: self.LoginInfo.govCodeStr,
        NUM: self.form.num,
        NUM2: self.form.num2,
        GOVTYPE: self.form.govtype,
        SYEAR: self.form.syear,
        CHECK_EDNODES: self.form.CHECK_EDNODES,
        LogInfo: {
          Id: self.LoginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "抽籤",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.LoginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));

      F101_Drawlots(postData).then((rData) => {
        // self.Alert.txt =  rData[0].indexOf("下列機關已完成抽籤送審")
        if (rData[0] == "ERROR") {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData[1]]; //["未有抽籤資料"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        } else if (rData.length >= 2 && rData[1] != "") {
          self.AlertRe.show = true;
          self.AlertRe.title = "提醒";
          //self.AlertRe.txt = rData.messages;
          self.AlertRe.btnReDrawLots = () => {
            F101_ReDrawlots(postData).then((reData) => {
              let link = document.createElement("a");
              link.download = "中籤名單";
              link.href = "data:application/pdf;base64," + reData;
              link.click();
              self.AlertRe.show = false;

              self.Alert.show = true;
              self.Alert.title = "重抽正確";
              self.Alert.txt = ["重新抽籤成功!請至F102維護中籤人員名單"];
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            });
          };
          self.AlertRe.btnDrawLotsClose = () => {
            //let link = document.createElement("a");
            // link.download = "中籤名單";
            // link.href = "data:application/pdf;base64," + rData[0];
            // link.click();
            // self.AlertRe.show = false;
            self.AlertRe.show = false;
            self.Alert.show = false;
            // self.Alert.title = "重抽未完成";
            // self.Alert.txt =["請至F102抽籤名單維護下載名單"];
            // self.Alert.BtnConfirm = () => (self.Alert.show = false);
          };
        } else {
          let link = document.createElement("a");
          link.download = "中籤名單";
          link.href = "data:application/pdf;base64," + rData[0];
          link.click();

          self.Alert.show = true;
          self.Alert.title = "正確";
          self.Alert.txt = ["抽籤成功!請至F102維護中籤人員名單"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnReDrawLots: function () {
      const self = this;
      self.AlertRe.show = false;
    },
    btnDrawLotsClose: function () {
      const self = this;
      self.AlertRe.show = false;
    },
    //統計參與抽籤人數
    btnLotcount: function () {
      const self = this;
      self.form.CHECK_EDNODES = sessionStorage.getItem("TreeItem");
      let postData = {
        RANK: "", //國防部專用
        LOGINID: self.LoginInfo.id,
        LOGINGOVCODE: self.LoginInfo.govCode,
        LOGINGOVCODESTR: self.LoginInfo.govCodeStr,
        NUM: self.form.num,
        NUM2: self.form.num2,
        GOVTYPE: self.form.govtype,
        SYEAR: self.form.syear,
        CHECK_EDNODES: self.form.CHECK_EDNODES,
        LogInfo: {
          Id: self.LoginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "統計參與抽籤人數",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.LoginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      F101_Lotcount(postData).then((rData) => {
        if (rData.returnObject) {
          self.form.modelCount = rData.returnObject.modelCount;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //瀏覽參與抽籤人員名單
    btnLotFindList: function () {
      const self = this;
      if (self.form.modelCount == "" || self.form.modelCount == "0") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["未有參與人數統計"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }
      self.form.CHECK_EDNODES = sessionStorage.getItem("TreeItem");
      let postData = {
        //國防部專用
        RANK: "",
        LOGINID: self.LoginInfo.id,
        LOGINGOVCODE: self.LoginInfo.govCode,
        LOGINGOVCODESTR: self.LoginInfo.govCodeStr,
        NUM: self.form.num,
        NUM2: self.form.num2,
        GOVTYPE: self.form.govtype,
        SYEAR: self.form.syear,
        CHECK_EDNODES: self.form.CHECK_EDNODES,
        LogInfo: {
          Id: self.LoginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "瀏覽參與抽籤人員名單",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.LoginInfo.token,
        },
      };
      F101_LotFindList(postData).then((rData) => {
        let link = document.createElement("a");
        link.download = "F101-2.xlsx";
        link.href = "data:application/vnd.ms-excel;base64," + rData;
        link.click();
      });
    },
    //重填
    btnClear: function () {
      const self = this;
      self.form = {
        syear: self.form.syear,
        govtype: "1",
        CHECK_EDNODES: "",
        num: "",
        nuM2: "",
        modelCount: "",
      };
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    sessionStorage.removeItem("TreeItem");
    self.doTree();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />

